const Display = ({ color, type }) => {
  const regular = (
    <svg
      width="24"
      height="24"
      viewBox="0 0 52 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.5402 0.507283C25.9718 0.883238 26.2196 1.42761 26.2196 2V14.4568L50.7308 24.2004C51.4844 24.4999 51.9791 25.2288 51.9792 26.0397L51.9817 45.9597C51.9818 46.9164 51.2977 47.7363 50.3565 47.9076L28.1544 51.9476C27.7526 52.0208 27.338 51.9678 26.9674 51.796L1.16743 39.836C0.467983 39.5118 0.020401 38.811 0.020401 38.04V5.08C0.020401 4.09163 0.749413 3.2547 1.72844 3.11911L23.9684 0.0391131C24.5354 -0.0394072 25.1086 0.131327 25.5402 0.507283ZM22.2604 15.7593V4.27264L3.9796 6.80434V17.9588L22.2603 25.5538L22.26 15.8C22.26 15.7864 22.2601 15.7728 22.2604 15.7593ZM23.48 30.3479L3.9796 22.2461V36.7757L25.8203 46.9004L25.82 31.3208L23.48 30.3479ZM29.7792 31.6577L29.7795 47.6277L48.0223 44.3081L48.0203 28.4039L29.7792 31.6577ZM42.8088 25.3118L26.2196 18.7173V27.1992L28.0235 27.9492L42.8088 25.3118Z"
        fill={color}
      />
    </svg>
  );

  const getSVGByType = (type) => {
    switch (type) {
      case "regular":
      default:
        return regular;
    }
  };

  return getSVGByType(type);
};

export default Display;
